import type { UserActor, User } from '@/entities'

export const createUserActor = (user: Pick<User, 'userId' | 'name' | 'avatar'>): UserActor => ({
    type: 'user',
    userId: user.userId,
    name: user.name,
    image: user.avatar ? { ...user.avatar } : null,
})
